export default {
    fvFromXLFilters: setInitialFVFromXLFilters(),
    setInitialFVFromXLFilters: setInitialFVFromXLFilters,
}

function setInitialFVFromXLFilters() {
    return {
        number: null,
        customerName: null,
        invoiceNumber: null,
        createdAt__gte: null,
        createdAt__lte: null,
    }
}
